import React, { useContext, useMemo } from "react";
import { ReactComponent as EstablishementIcon } from "../../public/icons/profil/EstablishementIcon.svg";
import { ReactComponent as ContactsIcon } from "../../public/icons/profil/ContactsIcon.svg";
import { ReactComponent as PasswordEditIcon } from "../../public/icons/profil/PasswordEditIcon.svg";
//import { ReactComponent as CreditCardIcon } from "../../../public/icons/profil/CreditCardIcon.svg";
import { ProfilWidgetItem } from "../../types";
import { CustomModalContext, LayoutBarContext } from "../../contexts";
import ReactSvgIcon from "../../components/UIElements/ReactSvgIcon";
import EditPasswordForm from "../../components/Profil/Password/EditPasswordForm";
import EstablishementInfos from "../../components/Profil/Client/EstablishemntInfos/EstablishmentInfos";
import Contacts from "../../components/Profil/Client/Contacts/Contacts";

export function useClientProfil() {
    const { updateModal, updateIsCustomModalActive } =
        useContext(CustomModalContext);

    const { updateIsLayoutBarActive, updateContent } =
        useContext(LayoutBarContext);

    const profilWidgetItems: ProfilWidgetItem[] = useMemo(
        () => [
            {
                icon: (
                    <ReactSvgIcon
                        width="1.5rem"
                        height="1.5rem"
                        ReactIcon={EstablishementIcon}
                    />
                ),
                title: "Informations sur l’établissement",
                onClick: () => {
                    updateContent(<EstablishementInfos />);
                    updateIsLayoutBarActive(true);
                },
            },
            {
                icon: (
                    <ReactSvgIcon
                        width="1.5rem"
                        height="1.5rem"
                        ReactIcon={ContactsIcon}
                    />
                ),
                title: "Contacts",
                onClick: () => {
                    updateContent(<Contacts />);
                    updateIsLayoutBarActive(true);
                },
            },
            {
                icon: (
                    <ReactSvgIcon
                        width="1.5rem"
                        height="1.5rem"
                        ReactIcon={PasswordEditIcon}
                    />
                ),
                title: "Modifier mon mot de passe",
                onClick: () => {
                    updateModal({
                        content: <EditPasswordForm />,
                        title: "Modifier mon mot de passe",
                    });
                    updateIsCustomModalActive(true);
                },
            },
        ],
        []
    );

    return { profilWidgetItems };
}
